export class DataValidationIssue {
  constructor(public path: string, public message: string) {}
}

export class RequestValidationError extends Error {
  constructor(public path: string, public errors: Array<DataValidationIssue>) {
    super();
  }
}
